import get from 'lodash/get';
import { useQuery } from '../../../tools/useQuery';
import GET_USER_ACCOUNT_NUMBER from './GetUserAccountNumber.gql';

const parseResult = result => {
  const initialState = {};

  const userAccountNumber = get(result, 'core.getDSUserAccountNumber');
  return {
    ...initialState,
    ...userAccountNumber,
  };
};

export const useGetUserAccountNumber = options => {
  const [queryResult, queryAction] = useQuery(GET_USER_ACCOUNT_NUMBER, {
    ...options,
    onCompleted: result => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });
  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
